import axios from "axios";
import APIURLMaker from "../../../utils/APIURLMaker";
import {
  buildTemplateCreatePayload,
  normalizeTemplate,
} from "../utils/templateAdapter";

export const fetchRootTemplates = async () => {
  const url = APIURLMaker("templates/getAllRootTemplates");
  const response = await axios.get(url);
  const items = Array.isArray(response?.data) ? response.data : [];
  return items
    .map((item) => normalizeTemplate(item, { source: "root" }))
    .filter(Boolean);
};

export const fetchUserTemplates = async () => {
  const url = APIURLMaker("templates/getAllUserTemplates");
  const response = await axios.get(url);
  const items = Array.isArray(response?.data) ? response.data : [];
  return items
    .map((item) => normalizeTemplate(item, { source: "user" }))
    .filter(Boolean);
};

export const fetchTemplates = async () => {
  const [rootTemplates, userTemplates] = await Promise.all([
    fetchRootTemplates().catch(() => []),
    fetchUserTemplates().catch(() => []),
  ]);
  return [...userTemplates, ...rootTemplates];
};

export const createRootTemplate = async ({ name, desc, fields, targetTypes, thumbnail }) => {
  const payload = buildTemplateCreatePayload(fields, {
    name,
    desc,
    targetTypes,
    thumbnail,
    source: "root",
  });
  const url = APIURLMaker("templates/createRootTemplate");
  const response = await axios.post(url, payload);
  return normalizeTemplate(response?.data, { source: "root" });
};

export const createUserTemplate = async ({ name, desc, fields, targetTypes, thumbnail }) => {
  const payload = buildTemplateCreatePayload(fields, {
    name,
    desc,
    targetTypes,
    thumbnail,
    source: "user",
  });
  const url = APIURLMaker("templates/createUserTemplate");
  const response = await axios.post(url, payload);
  return normalizeTemplate(response?.data, { source: "user" });
};

export const updateUserTemplate = async (
  templateId,
  { name, desc, fields, targetTypes, thumbnail }
) => {
  const id = String(templateId ?? "").trim();
  if (!id) {
    throw new Error("Template id is required.");
  }
  const payload = buildTemplateCreatePayload(fields, {
    name,
    desc,
    targetTypes,
    thumbnail,
    source: "user",
  });
  const url = APIURLMaker(`templates/updateUserTemplate/${encodeURIComponent(id)}`);
  const response = await axios.put(url, payload);
  return normalizeTemplate(response?.data, { source: "user" });
};

export const deleteUserTemplate = async (templateId) => {
  const id = String(templateId ?? "").trim();
  if (!id) {
    throw new Error("Template id is required.");
  }
  const url = APIURLMaker(`templates/deleteUserTemplate/${encodeURIComponent(id)}`);
  await axios.delete(url);
};

// Backward-compatible alias for existing call sites.
export const createTemplate = createUserTemplate;
